<script lang="ts" setup>
import type { PropType } from 'vue';

defineEmits<{
    'click': []
}>();

/**********
 * Init
 **********/
defineProps({
    disabledTooltip: {
        type: String,
        default: ''
    },
    tooltip: {
        type: [String, Object],
        default: ''
    },
    title: {
        type: String,
        default: ''
    },
    iconClasses: {
        type: String,
        default: 'sy-icon-standard'
    },
    icon: {
        type: String,
        default: 'settings'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    stroke: {
        type: Boolean,
        default: false
    },
    active: {
        type: Boolean,
        default: false
    },
    rotating: {
        type: Boolean,
        default: false
    },
    size: {
        type: String as PropType<'small' | 'medium'>,
        default: 'medium'
    }
});
</script>

<template>
    <button
        v-tooltip="disabled ? disabledTooltip : tooltip"
        :class="['sy-icon-button flex-container gap-3', {'small': size === 'small', 'sy-active' : active}]"
        :disabled="disabled"
        :title="title"
        data-test="button-icon"
        @click.stop="$emit('click')"
    >
        <span class="flex-container">
            <Icon
                :icon="icon"
                :class="[iconClasses]"
                :stroke="stroke"
                :spinning="rotating"
            />
        </span>
        <slot></slot>
    </button>
</template>

<style scoped lang="scss">
.sy-icon-button {
    border-width: 1px;
    border-color: transparent;
    border-style: solid;
    border-radius: var(--sy-border-radius-lg);
    padding: var(--sy-spacer-3);
    color: var(--sy-gray-700);

    &.small {
        padding: var(--sy-spacer-2);
        border-radius: var(--sy-border-radius);
    }

    & >svg {
        outline: none;
    }
    &:hover {
        border-color: var(--sy-gray-200);
        background-color: var(--sy-gray-200);
        & >svg {
            color: var(--sy-blue-600);
            &.sy-custom-icon {
                &.fill {
                    fill: var(--sy-blue-600);
                }

                &.stroke {
                    stroke: var(--sy-blue-600);
                }
            }
        }
    }
    &:disabled {
        cursor: not-allowed;
        color: var(--sy-gray-200);
        &:hover {
            background-color: var(--sy-gray-100);
        }
        & >svg {
            color: var(--sy-gray-400);
            &.sy-custom-icon {
                &.fill {
                    fill: var(--sy-gray-400);
                }

                &.stroke {
                    stroke: var(--sy-gray-400);
                }
            }
        }
    }
    &.sy-active {
        border-color: var(--sy-blue-100);
        background-color: var(--sy-blue-100);
        & span > svg {
            color: var(--sy-blue-600);
            &.sy-custom-icon {
                &.fill {
                    fill: var(--sy-blue-600);
                }

                &.stroke {
                    stroke: var(--sy-blue-600);
                }
            }
        }
    }
}
</style>
